import { Customer } from '../types';
import { CustomerOrGap } from './types';
import { isGap, Gap } from '../../helpers/paging';

export const customerPagingIdFn = (customer: CustomerOrGap): string | undefined => {
    if (isCustomer(customer)) {
        return customer.customer_id;
    }
    return customer.id;
};
export const getNextPageArgs = (customers: CustomerOrGap[]): { [key: string]: string } => {
    if (customers.length === 0) {
        return {};
    }
    const last = customers[customers.length - 1];
    return { starting_after: customerPagingIdFn(last) || '' };
};

export const getGapPageArgs = (customers: CustomerOrGap[], id: string): { [key: string]: string } => {
    const gap = customers.find((o) => isGap(o) && o.id === id);
    if (!gap) {
        return {};
    }
    return { starting_after: gap.id || '' };
};

export const isCustomer = (obj: CustomerOrGap): obj is Customer => {
    return (obj as Gap).gap !== true;
};
